'use client'

import CustomerQuote from '@/components/CustomerQuote'

const FortoCaseStudyQuoteOne = () => {
    return (
        <CustomerQuote
            backgroundImageSrc={'/images/forto-case-study/customer-quote-1-lg.png'}
            mobileBackgroundImageSrc={'/images/forto-case-study/customer-quote-1-sm.png'}
            text={
                <>
                    For us to be a frontrunner in sustainable logistics, we needed a solid
                    foundation to build on. You can&apos;t lead on shaky ground. With Lune&apos;s
                    reliable emission visibility, we&apos;ve transformed sustainability into a
                    commercial differentiator.
                </>
            }
            avatar={{
                title: 'Christian Volp',
                subtitle: 'Senior Sustainability Manager at Forto',
                imageSrc: '/images/forto-case-study/customer-quote-1-avatar.png',
            }}
            reversedOnMobile
        />
    )
}

export default FortoCaseStudyQuoteOne
